import MainPage from "../views/index.vue";
import CategoryView from '../views/category/index.vue';
import CategoryMap from '../views/category/map.vue';
import Page from '../views/page/index.vue';
import PageMap from '../views/page/map.vue';
import PageItem from "../views/page-item/view.vue";
import Page404 from "../views/_error/Page404.vue";

import { PageIdentity } from '../src/Entity/Page';

const routes = [
    {
        name: "main-page",
        path: '',
        component: MainPage
    },
    {
        name: "category",
        path: '/dt/:categoryUrlName',
        component: CategoryView,
        props: (route) => ({
            categoryUrlName: route.params.categoryUrlName,
        }),
    },
    {
        name: "category-map",
        path: '/dt/:categoryUrlName/map',
        component: CategoryMap,
        props: (route) => ({
            categoryUrlName: route.params.categoryUrlName,
        }),
    },
    {
        name: "page",
        path: '/dt/:categoryUrlName/:pageUrlName',
        component: Page,
        props: (route) => ({
            pageIdentity: new PageIdentity(
                route.params.categoryUrlName,
                route.params.pageUrlName,
            ),
        }),
    },
    {
        name: "page-map",
        path: '/dt/:categoryUrlName/:pageUrlName/map',
        component: PageMap,
        props: (route) => ({
            pageIdentity: new PageIdentity(
                route.params.categoryUrlName,
                route.params.pageUrlName,
            ),
        }),
    },
    {
        name: "page-item",
        path: '/dt/:categoryUrlName/:pageUrlName/:itemId',
        component: PageItem,
        props: (route) => ({
            pageIdentity: new PageIdentity(
                route.params.categoryUrlName,
                route.params.pageUrlName,
            ),
            itemId: route.params.itemId,
        }),
    },
    {
        name: '404',
        path: '/:pathMatch(.*)*',
        component: Page404,
    },
];

export default routes;
